export enum TipoDadoVariavelEnum {
  Decimal = 1,
  Inteiro = 2,
  Booleano = 3,
}
